import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { HttpService } from "src/app/http.service";
import { GlobalService } from "src/app/global.service";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
@Component({
  selector: "app-agent-confirm-order",
  templateUrl: "./agent-confirm-order.component.html",
  styleUrls: ["./agent-confirm-order.component.scss"],
})
export class AgentConfirmOrderComponent implements OnInit {
  @ViewChild("confirm_button", { static: false }) confirm_button: ElementRef;
  final_price: any;
  wallet_balance: any;
  business_type_id: any;
  order_details: any;
  is_wallet_selected = false;
  final_customer_wallet: any = null;
  final_price_after_wallet: any;
  order_date_list: any;
  selected_business_code: any;
  disable_button = false;
  is_session_wise_edit = null;
  business_id: any;
  business_group_id: 1;
  extra_milk_qty: any;
  extra_curd_qty: any;
  counter_id: any;
  constructor(
    public dialogRef: MatDialogRef<AgentConfirmOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private http: HttpService,
    private global: GlobalService
  ) {
    console.log(this.data);
    setTimeout(() => document.getElementById("register_button").focus(), 500);
    this.final_price = data["final_price"];
    this.order_date_list = data["order_dates"];
    this.wallet_balance = data["wallet_balance"];
    this.selected_business_code = data["business_code"];
    this.is_session_wise_edit = data["is_session_wise_edit"];
    this.order_details = data["order_details"];
    this.business_id = data["business_id"];
    this.counter_id = data["counter_id"];
    (this.business_group_id = data["business_group_id"]),
      (this.business_type_id = data["business_type_id"]);
    this.extra_milk_qty = data["extra_milk_qty"];
    this.extra_curd_qty = data["extra_allowance_qty"];
    this.global.set_counter_id = this.counter_id;

    if (this.business_type_id === 3 || this.business_type_id === 5) {
      this.is_wallet_selected = true;
      if (this.wallet_balance > 0) {
        this.final_price_after_wallet =
          data["final_price"] - data["wallet_balance"];
        this.final_customer_wallet =
          data["wallet_balance"] - data["final_price"];
        if (this.final_customer_wallet <= 0) {
          this.final_customer_wallet = 0;
        }
        if (this.final_price_after_wallet <= 0) {
          this.final_price_after_wallet = 0;
        }
      } else {
        this.final_price_after_wallet = data["final_price"];
        this.is_wallet_selected = false;
      }
    } else {
      this.final_price_after_wallet = data["final_price"];
      this.final_customer_wallet = data["wallet_balance"];
      this.is_wallet_selected = false;
    }
  }

  walletCheckboxChanged(event) {
    console.log("event called");
    if (!event.checked) {
      this.final_price_after_wallet = this.final_price;
      this.final_customer_wallet = this.wallet_balance;
    } else {
      this.final_price_after_wallet -= this.wallet_balance;
      this.final_customer_wallet = 0;
      if (this.final_price_after_wallet <= 0) {
        this.final_price_after_wallet = 0;
      }
    }
  }

  payClicked() {
    let session_list = [];
    if (this.is_session_wise_edit[1]) {
      session_list.push(1);
    }
    if (this.is_session_wise_edit[2]) {
      session_list.push(2);
    }
    let data_dict = {
      business_code: this.selected_business_code,
      order_date: this.order_date_list[0],
      session_list: session_list,
    };
    this.http.checkIndentStatus(data_dict).subscribe(
      (data) => {
        console.log(data);
        if (data) {
          let data_dict = {
            order_date: this.order_date_list,
            product_form_details: this.order_details,
            final_customer_wallet: this.final_customer_wallet,
            final_price: this.final_price_after_wallet,
            from: "portal",
            business_code: this.selected_business_code,
            is_wallet_selected: this.is_wallet_selected,
            business_type_id: this.business_type_id,
            extra_milk_qty:
              this.extra_milk_qty == null ? 0 : this.extra_milk_qty,
            extra_curd_qty:
              this.extra_curd_qty == null ? 0 : this.extra_curd_qty,
            counter_id: this.counter_id,
          };
          console.log(data_dict);

          if (this.business_group_id !== 1) {
            data_dict["business_id"] = this.business_id;
          } else {
            data_dict["business_group_id"] = 1;
          }
          if (this.business_group_id == 1) {
            data_dict["business_group_id"] = 1;
          } else {
            data_dict["business_id"] = this.business_id;
          }

          console.info(data_dict);
          this.disable_button = true;
          this.http
            .registerOrderForAgent(data_dict)
            .pipe(
              catchError((error) => {
                if (error.status === 400) {
                  alert(error["error"]["message"]);
                }
                console.error("Bad Request", error);
                this.disable_button = false;
                this.closeComponent(false);
                // Return an empty observable to keep the stream alive
                throw error;
              })
            )
            .subscribe(
              (data) => {
                console.info("saved");
                this.final_price = null;
                this.order_date_list = null;
                this.closeComponent(true);
                this.global.showSnakeBar("order saved success");
                this.disable_button = false;
              },
              // (error) => {
              //   this.disable_button = false;
              //   this.closeComponent(false);
              //   console.error(error);
              // }
            );
        } else {
          alert("Indent taken for this route you cannot order");
          this.disable_button = false;
          this.closeComponent(true);
          return false;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngOnInit() {}

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}

interface DialogData {
  agent_id: number;
  image_type: "";
}
